<template>
    <div>
        <v-container>
            <div class="d-flex justify-space-between mt-10 mb-5">
                <h2 class="mb-3">Sensitive Name Management</h2>
            </div>

            <v-text-field v-model="searchText"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          class="mb-3"
                          hide-details></v-text-field>

            <v-data-table :headers="headers"
                          :items="operators"
                          must-sort
                          item-key="key"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :server-items-length="totalItems"
                          :loading="isBusy"
                          :items-per-page.sync="pageSize"
                          :page.sync="pageNo"
                          class="elevation-1">

                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon v-bind="attrs"
                                   @click="onOpenUserOperatorModal(item)"
                                   v-on="on" color="lighten-2">
                                <v-icon>mdi-book-edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Update Operator Sensitive Names</span>
                    </v-tooltip>

                </template>

                <template v-slot:item.dateRegistered="{ item }">
                    {{ item.dateRegistered | DateTime }}
                </template>

            </v-data-table>
        </v-container>

        <sweet-modal :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" ref="updateUserOperatorModal" blocking>
            <v-progress-linear indeterminate
                               v-if="isBusy"
                               color="primary"></v-progress-linear>


            <v-form v-model="isFormValid" ref="operatorForm">
                <v-container>
                    <h3 class="mb-3">
                        Update {{ selectedOperatorName }}
                    </h3>
                    <h5>Larger names will be used to replace columns first.</h5>

                    <v-row class="mt-3">
                        <v-col cols="10" xs="10" lg="10">
                            <v-text-field :rules="wordRules" :counter="250" label="Sensitive Name" v-model="sensitiveWord"></v-text-field>
                        </v-col>
                        <v-col cols="2" xs="2" lg="2">
                            <v-btn class="mt-2"
                                   depressed color="primary"
                                   :disabled="!isFormValid || sensitiveWord.length === 0"
                                   @click="createOperatorSensitiveWord">
                                Add
                            </v-btn>
                        </v-col>
                    </v-row>

                    <div v-if="sensitiveNames.length === 0" class="w-100 text-center text-subtitle-1 ma-3">
                        No items found
                    </div>

                    <v-list two-line>
                        <template v-for="sensitiveName in sensitiveNames">
                            <v-list-item :key="sensitiveName.id">
                                <template v-slot:default="{  }">
                                    <v-list-item-content>

                                        <v-list-item-title v-text="sensitiveName.name"></v-list-item-title>

                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-btn depressed color="error" @click="deleteOperatorSensitiveWord(sensitiveName.id)">
                                            Remove
                                        </v-btn>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>


                        </template>
                    </v-list>

                    <div class="text-center pb-3" v-if="sensitiveNameTotalPages > 0">
                        <v-pagination v-model="sensitiveNamePageNo"
                                      :length="sensitiveNameTotalPages"
                                      circle></v-pagination>
                    </div>


                </v-container>
            </v-form>
        </sweet-modal>
    </div>
</template>
<script>
    import OperatorService from "../../services/operatorService.js"
    export default {
        name: 'SensitiveNameManagement',
        components: {
        },
        data: function () {
            return {
                isBusy: true,
                email: "",
                searchTimer: null,
                searchText: "",
                loading: true,
                pageNo: 1,
                pageSize: 10,
                accessToken: "",
                sensitiveWord: "",
                totalItems: 0,
                totalSensitiveNames: 0,
                wordRules: [
                    v => !!v || 'Sensitive word is required',
                    v => v && v.length <= 250 || 'Sensitive word must be less than 250 characters'
                ],
                sortBy: 'id',
                sortDesc: false,
                headers: [
                    {
                        text: 'Name',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    { text: '', value: 'actions', align: 'end', sortable: false },
                ],
                operators: [],
                sensitiveNames: [],
                isFormValid: false,
                selectedOperator: null,
                sensitiveNamePageNo: 1,
                sensitiveNamePageSize: 10
            }
        },
        watch: {
            pageNo: function () {
                this.searchOperators();
            },
            pageSize: function () {
                this.searchOperators();
            },
            searchText: function () {
                let self = this;
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(function () {
                    self.searchOperators();
                }, 1000);
            },
            sortBy: function () {
                this.searchOperators();
            },
            sortDesc: function () {
                this.searchOperators();
            }
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.searchOperators();
            },
            async searchOperators() {
                this.isBusy = true;
                var sortBy = this.sortBy ? "name" : this.sortBy;
                var sortDesc = this.sortDesc === false ? "ASCENDING" : "DESCENDING"
                const result = await OperatorService.searchOperators(this.accessToken, this.searchText, this.pageNo, this.pageSize, sortBy, sortDesc);
                this.operators = result.data.map((item, key) => ({ ...item, key }));
                this.totalItems = result.count;
                this.isBusy = false;
            },
            async createOperatorSensitiveWord() {
                this.isBusy = true;

                const request = {
                    name: this.sensitiveWord
                }
                const result = await OperatorService.createOperatorSensitiveName(this.accessToken, this.selectedOperator.id, request);

                if (result) {
                    await this.searchOperatorSensitiveNames();
                }

                this.isBusy = false;
            },
            async deleteOperatorSensitiveWord(operatorSensitiveWordId) {
                this.isBusy = true;

                const result = await OperatorService.deleteOperatorSensitiveName(this.accessToken, this.selectedOperator.id, operatorSensitiveWordId);

                if (result) {
                    await this.searchOperatorSensitiveNames();
                }

                this.isBusy = false;
            },
            async onOpenUserOperatorModal(operator) {
                this.selectedOperator = operator;
                await this.searchOperatorSensitiveNames();
                this.$refs.updateUserOperatorModal.open();
            },
            async searchOperatorSensitiveNames() {
                this.isBusy = true;
                this.sensitiveWord = "";
                this.$refs.operatorForm.reset();


                const result = await OperatorService.searchOperatorSensitiveNames(this.accessToken, this.selectedOperator.id, "", this.sensitiveNamePageNo, this.sensitiveNamePageSize, "Name", "ASCENDING");

                this.sensitiveNames = result.data;
                this.totalSensitiveNames = result.count;

                this.isBusy = false;
            }
        },
        created() {
            this.setup();
        },
        computed: {
            selectedOperatorName() {
                return this.selectedOperator === null ? "" : this.selectedOperator.name;
            },
            sensitiveNameTotalPages() {
                return Math.ceil(this.totalSensitiveNames / this.sensitiveNamePageSize);
            },
        }
    }
</script>
